import moment from "moment";
import React from "react";
import Table from "../../components/table/table";
import { Link } from "react-router-dom";
import { useAppContext } from "../../context/app.context";

export default function AvoirslistPage() {
  const { appInfos } = useAppContext();
  const csvRows = [
    { key: "avoirKind", label: "Type avoir" },
    { key: "numAvoir", label: "Numéro avoir" },
    { key: "numFactureOrigin", label: "Facture d'origine" },
    { key: "priceHT", label: "Montant HT" },
    { key: "priceTTC", label: "Montant TTC" },
    { key: "motif", label: "Motif" },
    { key: "created_at", label: "Date de création" },
  ];

  const columns = [
    {
      accessorKey: "avoirKind",
      header: "Type",
      size: 20,
      filterVariant: "multi-select",
      filterSelectOptions: [
        { label: "AV (PRUMS)", value: "AV" },
        { label: "AVJ (Jobber)", value: "AVJ" },
      ],
      accessorFn: (row: any) => row.avoirKind || (String(row.numAvoir || "").startsWith("AVJ") ? "AVJ" : "AV"),
    },
    {
      accessorKey: "numAvoir",
      header: "Numéro avoir",
      size: 30,
    },
    {
      accessorKey: "numFactureOrigin",
      header: "Facture d'origine",
      size: 30,
      Cell: ({ cell }: any) => {
        const id = cell.row.original.idFactureOrigin?._id || cell.row.original.idFactureOrigin;
        return id ? (
          <Link to={"/factures/" + id}>{cell.getValue()}</Link>
        ) : (
          cell.getValue()
        );
      },
    },
    {
      accessorKey: "priceHT",
      header: "Montant HT",
      size: 30,
      accessorFn: (row: any) => (+row.priceHT).toFixed(2) + " €",
    },
    {
      accessorKey: "priceTTC",
      header: "Montant TTC",
      size: 30,
      accessorFn: (row: any) => (+row.priceTTC).toFixed(2) + " €",
    },
    {
      accessorKey: "motif",
      header: "Motif",
    },
    {
      accessorFn: (originalRow: any) => new Date(originalRow.created_at),
      header: "Date de création",
      filterVariant: "date-range",
      sortingFn: "datetime",
      Cell: ({ cell }: any) => moment(+cell.getValue()).format("DD/MM/YYYY"),
      type: "date",
    },
  ];

  function DownloadAvoirBtn(p: any) {
    return (
      <a
        href={
          process.env.REACT_APP_SERVER_URL +
          "/api/avoirs/avoirpdf/" +
          (p.row.original._id || p.row.original.id) +
          "?token=" +
          appInfos.token
        }
      >
        <span className="action">
          <img style={{ marginLeft: 10 }} src="/images/download.svg" alt="télécharger" />
        </span>
      </a>
    );
  }

  return (
    <Table
      hideAdd
      hideEdit
      hideDelete
      extracolumnActions={DownloadAvoirBtn}
      dataUrl="avoirs"
      columns={columns}
      csvRows={csvRows}
      permission="avoirs"
      showExport
      title="Avoirs"
    />
  );
}
